import React, { FunctionComponent } from 'react';
import type { CompanyDetailInformationChildProps as Props } from './types';

export const Presentation: FunctionComponent<Props> = ({
  FixedTitle,
  Title,
  description,
  image1,
  Image1Description = '',
  image2,
  Image2Description = '',
}) => {
  const shouldRender = (Title && Title !== '') || (description && description !== '');
  const images = [
    { hasImage: image1 !== null, url: image1?.url, description: Image1Description, alt: String(image1) },
    { hasImage: image2 !== null, url: image2?.url, description: Image2Description, alt: String(image2) },
  ].filter((image) => image.hasImage);

  return (
    <>
      {shouldRender && (
        <div className="company__page__information">
          <h2 className="company__page__information--subject">{FixedTitle}</h2>
          <p className="company__page__information--title">{Title}</p>

          <div className="company__page__information__wrapper">
            <div
              className="company__page__information__wrapper--text"
              dangerouslySetInnerHTML={{ __html: description }}
            />
            {images.length > 0 && (
              <ul className="js-company-information">
                {images.map((image, index) => (
                  <li key={index}>
                    <img src={image.url} alt={`${image.alt}のロゴ写真`} />
                    <p>{image.description}</p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </>
  );
};
